import React, { useContext, useState, Fragment } from "react";
import {
  IconButton,
  TableRow,
  TableCell,
  Autocomplete,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useQuery } from "@apollo/client";
import { NumericFormat } from "react-number-format";
//date picker
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
//Icons
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
//Srcs
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { GET_SUPPLIER_WITH_PAGINATION } from "../../Schema/Supplier";
import CreateSupplier from "../Supplier/CreateSupplier";

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumericFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      onFocus={(e) => e.target.select()}
      // isNumericString
    />
  );
}

export default function ListExpense({
  mainItem,
  requiredField,
  deleteExpensetList,
  setUpdateDate,
  setUpdateDescription,
  setUpdateSupplier,
  setUpdateInvoiceNumber,
  setUpdateExchangeRate,
  setUpdateQuantity,
  setUpdatePriceKh,
  setUpdatePriceUsd,
}) {
  //Change language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [touched, steTouched] = useState(false);
  const handleTouch = () => steTouched(true);
  let errorMessage = "require!";
  let qtyMessage = ["require!", "bigger than 0!"];

  const [supplierOptions, setSupplierOptions] = useState([]);

  // ============================== Set data into array list ============================

  const { refetch: refetchSupplier } = useQuery(GET_SUPPLIER_WITH_PAGINATION, {
    variables: {
      page: 1,
      limit: 500,
      keyword: "",
    },
    onCompleted: ({ getSupplierPagination }) => {
      // console.log("getSupplierPagination", getSupplierPagination);
      if (getSupplierPagination?.data) {
        let rows = [{ id: "Create", title: "New Supplier" }];
        getSupplierPagination?.data?.map((e) => {
          const allRow = {
            id: e?._id,
            title: e?.name,
          };
          rows.push(allRow);
        });
        setSupplierOptions(rows);
      }
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const ListItems = mainItem?.items?.map((item) => {
    console.log("item::", item);
    // console.log("mainItem::", mainItem)
    return (
      <Fragment key={item?.key}>
        <TableRow>
          <TableCell className="disbursement-header-title">
            <TextField
              fullWidth
              type="text"
              size="small"
              value={item?.invNo}
              placeholder={t("label_invoice_number")}
              onChange={(e) => {
                setUpdateInvoiceNumber(
                  mainItem?.key,
                  item?.key,
                  e?.target.value
                );
              }}
            />
          </TableCell>
          <TableCell className="disbursement-header-title">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={item?.invDate}
                inputFormat="dd-MM-yyyy"
                onChange={(newValue) =>
                  setUpdateDate(mainItem?.key, item?.key, newValue)
                }
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </TableCell>
          <TableCell className="disbursement-header-title">
            <TextField
              size="small"
              fullWidth
              placeholder="description"
              value={item?.description}
              onChange={(e) =>
                setUpdateDescription(mainItem?.key, item?.key, e?.target?.value)
              }
            />
          </TableCell>
          <TableCell className="disbursement-header-title">
            <Autocomplete
              disablePortal
              options={supplierOptions}
              value={{ id: item?.supplierId, title: item?.supplierName }}
              onChange={(e, value) => {
                if (value?.id === "Create") {
                  handleOpen();
                } else {
                  setUpdateSupplier(
                    mainItem?.key,
                    item?.key,
                    value?.id,
                    value?.title
                  );
                }
              }}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              getOptionLabel={(option) =>
                option.title === undefined ? "" : option.title
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="disbursement-field"
                  size="small"
                  placeholder="supplier"
                  onFocus={handleTouch}
                  error={
                    (touched && item?.supplierId === undefined) ||
                    (requiredField && item?.supplierId === "") ||
                    (requiredField && item?.supplierId === undefined)
                  }
                  helperText={
                    (touched &&
                      item?.supplierId === undefined &&
                      errorMessage) ||
                    (requiredField &&
                      item?.supplierId === "" &&
                      errorMessage) ||
                    (requiredField &&
                      item?.supplierId === undefined &&
                      errorMessage)
                  }
                />
              )}
            />
          </TableCell>

          <TableCell className="disbursement-header-title">
            <TextField
              fullWidth
              type="number"
              size="small"
              inputProps={{ min: 0 }}
              value={item?.qty}
              placeholder="qty"
              onChange={(e) => {
                setUpdateQuantity(mainItem?.key, item?.key, e?.target.value);
              }}
              onFocus={handleTouch}
              error={
                (touched && item?.qty < 0) ||
                (touched && isNaN(item?.qty)) ||
                (requiredField && item?.qty === undefined) ||
                (requiredField && item?.qty === "") ||
                (requiredField && item?.qty === 0)
              }
              helperText={
                (touched && item?.qty < 0 && qtyMessage[1]) ||
                (touched && isNaN(item?.qty) && qtyMessage[1]) ||
                (requiredField && item?.qty === undefined && qtyMessage[0]) ||
                (requiredField && item?.qty === "" && qtyMessage[0]) ||
                (requiredField && item?.qty === 0 && qtyMessage[1])
              }
            />
          </TableCell>
          <TableCell className="disbursement-header-title">
            <TextField
              fullWidth
              size="small"
              // inputProps={{ min: 0 }}
              name="NumericFormat"
              id="formatted-numberformat-input"
              onFocus={(e) => e.target.select()}
              InputProps={{
                inputComponent: NumberFormatCustom,
                endAdornment: <InputAdornment position="end">៛</InputAdornment>,
              }}
              value={item?.exchangeRate}
              placeholder="exchange rate"
              onChange={(e) => {
                setUpdateExchangeRate(
                  mainItem?.key,
                  item?.key,
                  e?.target.value
                );
              }}
            />
          </TableCell>
          <TableCell className="disbursement-header-title">
            <TextField
              fullWidth
              size="small"
              // inputProps={{ min: 0 }}
              name="NumericFormat"
              id="formatted-numberformat-input"
              onFocus={(e) => e.target.select()}
              InputProps={{
                inputComponent: NumberFormatCustom,
                endAdornment: <InputAdornment position="end">៛</InputAdornment>,
              }}
              value={item?.priceKHR}
              placeholder="price KH"
              onChange={(e) => {
                setUpdatePriceKh(mainItem?.key, item?.key, e?.target.value);
              }}
            />
          </TableCell>
          <TableCell className="disbursement-header-title">
            <TextField
              fullWidth
              size="small"
              // inputProps={{ min: 0 }}
              name="NumericFormat"
              id="formatted-numberformat-input"
              onFocus={(e) => e.target.select()}
              InputProps={{
                inputComponent: NumberFormatCustom,
                endAdornment: <InputAdornment position="end">$</InputAdornment>,
              }}
              value={item?.priceUSD}
              placeholder="price USD"
              onChange={(e) => {
                setUpdatePriceUsd(mainItem?.key, item?.key, e?.target.value);
              }}
            />
          </TableCell>
          {/* <TableCell className="disbursement-header-title">
          <TextField
            fullWidth
            size="small"
            disabled
            value={item?.qty * item?.priceInKHR}
            name="NumericFormat"
            id="formatted-numberformat-input"
            onFocus={(e) => e.target.select()}
            InputProps={{
              inputComponent: NumberFormatCustom,
              endAdornment: <InputAdornment position="end">៛</InputAdornment>,
            }}
            placeholder="amount KH"
          />
        </TableCell> */}
          {/* <TableCell className="disbursement-header-title">
          <TextField
            fullWidth
            size="small"
            disabled
            value={item?.qty * item?.priceInUSD}
            name="NumericFormat"
            id="formatted-numberformat-input"
            onFocus={(e) => e.target.select()}
            InputProps={{
              inputComponent: NumberFormatCustom,
              endAdornment: <InputAdornment position="end">$</InputAdornment>,
            }}
            placeholder="amount USD"
          />
        </TableCell> */}
          <TableCell className="disbursement-header-title" align="right">
            {item?.payments?.length > 0 ? null : (
              <IconButton
                onClick={() => deleteExpensetList(mainItem?.key, item?.key)}
              >
                <RemoveCircleIcon sx={{ color: "red" }} />
              </IconButton>
            )}
          </TableCell>
        </TableRow>
      </Fragment>
    );
  });

  return (
    <>
      <CreateSupplier
        open={open}
        handleClose={handleClose}
        setRefetch={refetchSupplier}
      />
      {ListItems}
    </>
  );
}
